<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6 mb-4">
          <SSLInfo :site="site" />
        </div>
        <div class="col-md-6 mb-4">
          <LetsEncrypt :site="site" />
        </div>
      </div>
      <div class="row" v-if="!letsencryptEnabled && letsencryptEnabledStatus.isLoaded">
        <div class="col-md-12 mb-4">
          <CertificateInstall :site="site" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CertificateInstall from "@/components/smart/cards/CertificateInstall";
import { computed } from "@vue/composition-api";
import LetsEncrypt from "@/components/smart/cards/LetsEncrypt";
import SSLInfo from "@/components/smart/cards/SSLInfo";
import store from "@/store";

export default {
  name: "SharedHostSafeHarborStagingEnvironmentSslPage",
  components: {
    SSLInfo,
    LetsEncrypt,
    CertificateInstall,
  },
  setup() {
    const site = computed(() => store.getters["devSites/getItem"]);
    const letsencryptEnabled = computed(() => store.getters["letsencrypt/getEnabled"]);
    const letsencryptEnabledStatus = computed(() => store.getters["letsencrypt/getEnabledStatus"]);

    return {
      site,
      letsencryptEnabled,
      letsencryptEnabledStatus,
    };
  },
};
</script>
